var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}],staticClass:"dropdown-element",class:{ _open: _vm.sharedState.active },on:{"click":_vm.toggle}},[_vm._t("toggler",function(){return [_c('button',[_vm._v("Toggle")])]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }